/*
 * This file is generated by ~/modules/gql.ts
 * Do not edit this file manually
 */

import type {
  GetOrCreateOperationTransactionQuery,
  GetOrCreateOperationTransactionQueryVariables,
  AccountFileQuery,
  AccountFileQueryVariables,
  ChangePasswordMutation,
  ChangePasswordMutationVariables,
  CheckNidQuery,
  CheckNidQueryVariables,
  CurrentCustodyQuery,
  CurrentCustodyQueryVariables,
  DeleteAccountMutation,
  DeleteAccountMutationVariables,
  DeleteAccountConfirmMutation,
  DeleteAccountConfirmMutationVariables,
  DeleteAccountResendSmsMutation,
  DeleteAccountResendSmsMutationVariables,
  FullNameQuery,
  FullNameQueryVariables,
  InvestorEquityQuery,
  InvestorEquityQueryVariables,
  OperationExclusiveQuery,
  OperationExclusiveQueryVariables,
  SendAccountSuitabilityMutation,
  SendAccountSuitabilityMutationVariables,
  UpdateInvestorEquityMutation,
  UpdateInvestorEquityMutationVariables,
  UserQuery,
  UserQueryVariables,
  AddressQuery,
  AddressQueryVariables,
  AddressFromPostalCodeQuery,
  AddressFromPostalCodeQueryVariables,
  BrazilianStatesQuery,
  BrazilianStatesQueryVariables,
  CitiesByStateQuery,
  CitiesByStateQueryVariables,
  UpdateAddressMutation,
  UpdateAddressMutationVariables,
  AddBankInfoMutation,
  AddBankInfoMutationVariables,
  BankInfoQuery,
  BankInfoQueryVariables,
  RemoveUserBankInfoMutation,
  RemoveUserBankInfoMutationVariables,
  UpdateUserBankInfoMutation,
  UpdateUserBankInfoMutationVariables,
  RequestDeleteAccountMutation,
  RequestDeleteAccountMutationVariables,
  RequestDeleteAccountConfirmMutation,
  RequestDeleteAccountConfirmMutationVariables,
  RequestDeleteAccountResendEmailMutation,
  RequestDeleteAccountResendEmailMutationVariables,
  RequestDeleteAccountResendSmsMutation,
  RequestDeleteAccountResendSmsMutationVariables,
  CheckEmailQuery,
  CheckEmailQueryVariables,
  ConfirmAccountEmailChangeMutation,
  ConfirmAccountEmailChangeMutationVariables,
  RequestAccountEmailChangeMutation,
  RequestAccountEmailChangeMutationVariables,
  ResendEmailChangeConfirmationCodeMutation,
  ResendEmailChangeConfirmationCodeMutationVariables,
  PatrimonialDataQuery,
  PatrimonialDataQueryVariables,
  PopulateUserPatrimonialDataMutation,
  PopulateUserPatrimonialDataMutationVariables,
  UpdatePatrimonialDataMutation,
  UpdatePatrimonialDataMutationVariables,
  PatrimonialDataStatusQuery,
  PatrimonialDataStatusQueryVariables,
  CheckPhoneQuery,
  CheckPhoneQueryVariables,
  ConfirmAccountPhoneChangeMutation,
  ConfirmAccountPhoneChangeMutationVariables,
  RequestAccountPhoneChangeMutation,
  RequestAccountPhoneChangeMutationVariables,
  ResendPhoneChangeConfirmationCodeMutation,
  ResendPhoneChangeConfirmationCodeMutationVariables,
  AddPixInfoMutation,
  AddPixInfoMutationVariables,
  PixInfoQuery,
  PixInfoQueryVariables,
  RemovePixInfoMutation,
  RemovePixInfoMutationVariables,
  AcceptProspectingPortfolioMutation,
  AcceptProspectingPortfolioMutationVariables,
  CancelInvestmentBasketMutation,
  CancelInvestmentBasketMutationVariables,
  ConfirmCodeInvestmentBasketMutation,
  ConfirmCodeInvestmentBasketMutationVariables,
  ConfirmInvestmentBasketMutation,
  ConfirmInvestmentBasketMutationVariables,
  CreatePreProspectingPortfolioMutation,
  CreatePreProspectingPortfolioMutationVariables,
  FindOneInvestmentBasketQuery,
  FindOneInvestmentBasketQueryVariables,
  GetBasketOperationsStatusQuery,
  GetBasketOperationsStatusQueryVariables,
  ResendInvestmentBasketEmailCodeMutation,
  ResendInvestmentBasketEmailCodeMutationVariables,
  ResendInvestmentBasketSmsCodeMutation,
  ResendInvestmentBasketSmsCodeMutationVariables,
  ResendInvestmentBasketWhatsappCodeMutation,
  ResendInvestmentBasketWhatsappCodeMutationVariables,
  UpdateInvestmentBasketInvestorEquityMutation,
  UpdateInvestmentBasketInvestorEquityMutationVariables,
  UpdateViewedBasketMutation,
  UpdateViewedBasketMutationVariables,
  HurstBanksQuery,
  HurstBanksQueryVariables,
  OriginatorsQuery,
  OriginatorsQueryVariables,
  ConfirmInvestmentWithCodeMutation,
  ConfirmInvestmentWithCodeMutationVariables,
  ResendCodeConfirmInvestmentEmailMutation,
  ResendCodeConfirmInvestmentEmailMutationVariables,
  ResendCodeConfirmInvestmentSmsMutation,
  ResendCodeConfirmInvestmentSmsMutationVariables,
  SignContractInvestmentMutation,
  SignContractInvestmentMutationVariables,
  UpdateTransactionMutation,
  UpdateTransactionMutationVariables,
  HcpPortfolioOperationCashflowQuery,
  HcpPortfolioOperationCashflowQueryVariables,
  ActivateIndicationCodeMutation,
  ActivateIndicationCodeMutationVariables,
  CheckIndicationCodeQuery,
  CheckIndicationCodeQueryVariables,
  GetAllIndicatedUsersQuery,
  GetAllIndicatedUsersQueryVariables,
  IndicationInfoQuery,
  IndicationInfoQueryVariables,
  RegisterAccountIndicationCodeMutation,
  RegisterAccountIndicationCodeMutationVariables,
  CheckCouponQuery,
  CheckCouponQueryVariables,
  LoginMutation,
  LoginMutationVariables,
  AvailableOperationQuery,
  AvailableOperationQueryVariables,
  OpportunitiesDetailQuery,
  OpportunitiesDetailQueryVariables,
  QueryAddressByZipCodeQuery,
  QueryAddressByZipCodeQueryVariables,
  QueryConstantsByScopeQuery,
  QueryConstantsByScopeQueryVariables,
  GetAddressInfoQuery,
  GetAddressInfoQueryVariables,
  GetAmountInvestInfoQuery,
  GetAmountInvestInfoQueryVariables,
  GetBankInfoQuery,
  GetBankInfoQueryVariables,
  GetBasicInfoQuery,
  GetBasicInfoQueryVariables,
  GetBiometricDataInfoQuery,
  GetBiometricDataInfoQueryVariables,
  GetContactInfoQuery,
  GetContactInfoQueryVariables,
  GetDocumentDataInfoQuery,
  GetDocumentDataInfoQueryVariables,
  GetInvestorEquityInfoQuery,
  GetInvestorEquityInfoQueryVariables,
  GetPasswordInfoQuery,
  GetPasswordInfoQueryVariables,
  GetPatrimonialDataInfoQuery,
  GetPatrimonialDataInfoQueryVariables,
  GetPersonalInfoQuery,
  GetPersonalInfoQueryVariables,
  GetRegisterAccountValidationInfoQuery,
  GetRegisterAccountValidationInfoQueryVariables,
  GetStatementInfoQuery,
  GetStatementInfoQueryVariables,
  GetUploadDocumentInfoQuery,
  GetUploadDocumentInfoQueryVariables,
  GetWhenInvestInfoQuery,
  GetWhenInvestInfoQueryVariables,
  QueryAccountRegisterStatusQuery,
  QueryAccountRegisterStatusQueryVariables,
  RegisterAccountAddressMutation,
  RegisterAccountAddressMutationVariables,
  RegisterAccountAmountInvestMutation,
  RegisterAccountAmountInvestMutationVariables,
  RegisterAccountBasicInfoMutation,
  RegisterAccountBasicInfoMutationVariables,
  RegisterAccountGenerateDocumentUploadUrlsMutation,
  RegisterAccountGenerateDocumentUploadUrlsMutationVariables,
  RegisterAccountInvestorEquityMutation,
  RegisterAccountInvestorEquityMutationVariables,
  RegisterAccountKycValidationMutation,
  RegisterAccountKycValidationMutationVariables,
  RegisterAccountPasswordMutation,
  RegisterAccountPasswordMutationVariables,
  RegisterAccountPatrimonialDataMutation,
  RegisterAccountPatrimonialDataMutationVariables,
  RegisterAccountPersonalDataMutation,
  RegisterAccountPersonalDataMutationVariables,
  RegisterAccountSaveBiometricDataMutation,
  RegisterAccountSaveBiometricDataMutationVariables,
  RegisterAccountSaveUserDocumentsMutation,
  RegisterAccountSaveUserDocumentsMutationVariables,
  RegisterAccountSendCodeViaEmailMutation,
  RegisterAccountSendCodeViaEmailMutationVariables,
  RegisterAccountSendCodeViaSmsMutation,
  RegisterAccountSendCodeViaSmsMutationVariables,
  RegisterAccountSendCodeViaWhatsappMutation,
  RegisterAccountSendCodeViaWhatsappMutationVariables,
  RegisterAccountStatementsMutation,
  RegisterAccountStatementsMutationVariables,
  RegisterAccountVerifyEmailMutation,
  RegisterAccountVerifyEmailMutationVariables,
  RegisterAccountVerifyPhoneNumberMutation,
  RegisterAccountVerifyPhoneNumberMutationVariables,
  RegisterAccountWhenInvestMutation,
  RegisterAccountWhenInvestMutationVariables,
  RegisterBankAccountMutation,
  RegisterBankAccountMutationVariables,
  RegisterUserIdentificationMutation,
  RegisterUserIdentificationMutationVariables,
  ConfirmResetPasswordMutation,
  ConfirmResetPasswordMutationVariables,
  RequestResetPasswordMutation,
  RequestResetPasswordMutationVariables,
  ResendResetPasswordConfirmationCodeMutation,
  ResendResetPasswordConfirmationCodeMutationVariables,
  GetOrCreateTransactionQuery,
  GetOrCreateTransactionQueryVariables,
  WalletOperationQuery,
  WalletOperationQueryVariables,
} from "~/graphql/generated/graphql";

export const useGqlGetOrCreateOperationTransaction = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetOrCreateOperationTransactionQueryVariables) => {
    return $gql<GetOrCreateOperationTransactionQuery>(
      `query GetOrCreateOperationTransaction($operationId: String!){user{investorEquity investorEquityUpdatedAt}getOrCreateTransaction(operationId: $operationId){transaction{transactionId amountCommitted amountConfirmed transactionStatus}operation{id assetName assetSymbol url baseAssetSymbol name exclusiveForQualifiedInvestors type assetName category estimatedIRR estimatedDuration estimatedCompositeDuration durationTerm maxRaise minRaise contractFile{fileName}}}}`,
      variables,
    );
  };
};

export const useGqlAccountFile = () => {
  const { $gql } = useNuxtApp();

  return (variables?: AccountFileQueryVariables) => {
    return $gql<AccountFileQuery>(
      `query AccountFile{accountFile{documentType fileId fileName createdAt fileUrl accountId fileDescription isVisible title uploadedBy}}`,
      variables,
    );
  };
};

export const useGqlChangePassword = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ChangePasswordMutationVariables) => {
    return $gql<ChangePasswordMutation>(
      `mutation ChangePassword($currentPassword: String!, $newPassword: String!){changePassword(currentPassword: $currentPassword, newPassword: $newPassword){__typename}}`,
      variables,
    );
  };
};

export const useGqlCheckNid = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CheckNidQueryVariables) => {
    return $gql<CheckNidQuery>(
      `query CheckNid($nid: String!){checkNid(input:{nid: $nid}){available}}`,
      variables,
    );
  };
};

export const useGqlCurrentCustody = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CurrentCustodyQueryVariables) => {
    return $gql<CurrentCustodyQuery>(
      `query CurrentCustody{accountCurrentCustody{amount}}`,
      variables,
    );
  };
};

export const useGqlDeleteAccount = () => {
  const { $gql } = useNuxtApp();

  return (variables?: DeleteAccountMutationVariables) => {
    return $gql<DeleteAccountMutation>(
      `mutation DeleteAccount{requestDeleteAccount(input:{verificationCodeMethod: phone}){message success}}`,
      variables,
    );
  };
};

export const useGqlDeleteAccountConfirm = () => {
  const { $gql } = useNuxtApp();

  return (variables?: DeleteAccountConfirmMutationVariables) => {
    return $gql<DeleteAccountConfirmMutation>(
      `mutation DeleteAccountConfirm($code: String!){requestDeleteAccountConfirm(input:{code: $code}){message success}}`,
      variables,
    );
  };
};

export const useGqlDeleteAccountResendSms = () => {
  const { $gql } = useNuxtApp();

  return (variables?: DeleteAccountResendSmsMutationVariables) => {
    return $gql<DeleteAccountResendSmsMutation>(
      `mutation DeleteAccountResendSms{requestDeleteAccountResendSms{message success}}`,
      variables,
    );
  };
};

export const useGqlFullName = () => {
  const { $gql } = useNuxtApp();

  return (variables?: FullNameQueryVariables) => {
    return $gql<FullNameQuery>(
      `query FullName{user{fullName id nid}}`,
      variables,
    );
  };
};

export const useGqlInvestorEquity = () => {
  const { $gql } = useNuxtApp();

  return (variables?: InvestorEquityQueryVariables) => {
    return $gql<InvestorEquityQuery>(
      `query InvestorEquity{user{investorEquity investorEquityUpdatedAt}}`,
      variables,
    );
  };
};

export const useGqlOperationExclusive = () => {
  const { $gql } = useNuxtApp();

  return (variables?: OperationExclusiveQueryVariables) => {
    return $gql<OperationExclusiveQuery>(
      `query OperationExclusive($operationId: String!){operation(operationId: $operationId){items{id assetSymbol exclusiveForQualifiedInvestors}}}`,
      variables,
    );
  };
};

export const useGqlSendAccountSuitability = () => {
  const { $gql } = useNuxtApp();

  return (variables?: SendAccountSuitabilityMutationVariables) => {
    return $gql<SendAccountSuitabilityMutation>(
      `mutation SendAccountSuitability($input: SuitabilityAnswerInput!){accountSuitability(input: $input){message success data{accountId suitabilityInvestorProfile}}}`,
      variables,
    );
  };
};

export const useGqlUpdateInvestorEquity = () => {
  const { $gql } = useNuxtApp();

  return (variables?: UpdateInvestorEquityMutationVariables) => {
    return $gql<UpdateInvestorEquityMutation>(
      `mutation UpdateInvestorEquity($investorEquity: AccountQualifiedInvestor!){personalInfoKycInvestorEquity(input:{investorEquity: $investorEquity}){__typename}}`,
      variables,
    );
  };
};

export const useGqlUser = () => {
  const { $gql } = useNuxtApp();

  return (variables?: UserQueryVariables) => {
    return $gql<UserQuery>(
      `query User{user{registerCodeStatus birthdate category fullName nickName email phone gender maritalStatus nationality nid taxId profession partner kycAML{status}patrimonialData{financialInvestments others monthlyIncome realOrAlternative personalty chattel}}}`,
      variables,
    );
  };
};

export const useGqlAddress = () => {
  const { $gql } = useNuxtApp();

  return (variables?: AddressQueryVariables) => {
    return $gql<AddressQuery>(
      `query Address{user{address{city complement country nationality neighborhood number postalCode state street}}}`,
      variables,
    );
  };
};

export const useGqlAddressFromPostalCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: AddressFromPostalCodeQueryVariables) => {
    return $gql<AddressFromPostalCodeQuery>(
      `query AddressFromPostalCode($zipcode: String!){zipcode(zipcode: $zipcode){city neighborhood service state street zipcode}}`,
      variables,
    );
  };
};

export const useGqlBrazilianStates = () => {
  const { $gql } = useNuxtApp();

  return (variables?: BrazilianStatesQueryVariables) => {
    return $gql<BrazilianStatesQuery>(
      `query BrazilianStates{states{code name}}`,
      variables,
    );
  };
};

export const useGqlCitiesByState = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CitiesByStateQueryVariables) => {
    return $gql<CitiesByStateQuery>(
      `query CitiesByState($state: String!){regions(code: $state){name}}`,
      variables,
    );
  };
};

export const useGqlUpdateAddress = () => {
  const { $gql } = useNuxtApp();

  return (variables?: UpdateAddressMutationVariables) => {
    return $gql<UpdateAddressMutation>(
      `mutation UpdateAddress($address: UpdateAddressDTO!){updateAddress(updateAddressDTO: $address){__typename}}`,
      variables,
    );
  };
};

export const useGqlAddBankInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: AddBankInfoMutationVariables) => {
    return $gql<AddBankInfoMutation>(
      `mutation AddBankInfo($bankInfo: CreateUserBankInfoDTO!){createUserBankInfo(createUserBankInfoDTO: $bankInfo){__typename}}`,
      variables,
    );
  };
};

export const useGqlBankInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: BankInfoQueryVariables) => {
    return $gql<BankInfoQuery>(
      `query BankInfo{user{bankInfo{agency bank bankCode cc default type}}}`,
      variables,
    );
  };
};

export const useGqlRemoveUserBankInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RemoveUserBankInfoMutationVariables) => {
    return $gql<RemoveUserBankInfoMutation>(
      `mutation RemoveUserBankInfo($bankInfo: RemoveUserBankInfoDTO!){removeUserBankInfo(input: $bankInfo){__typename}}`,
      variables,
    );
  };
};

export const useGqlUpdateUserBankInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: UpdateUserBankInfoMutationVariables) => {
    return $gql<UpdateUserBankInfoMutation>(
      `mutation UpdateUserBankInfo($bankId: String! $bankInfo: UpdateUserBankInfoDTO!){updateUserBankInfo(bankId: $bankId, updateUserBankInfoDTO: $bankInfo){__typename}}`,
      variables,
    );
  };
};

export const useGqlRequestDeleteAccount = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RequestDeleteAccountMutationVariables) => {
    return $gql<RequestDeleteAccountMutation>(
      `mutation RequestDeleteAccount{requestDeleteAccount(input:{verificationCodeMethod: phone}){message success}}`,
      variables,
    );
  };
};

export const useGqlRequestDeleteAccountConfirm = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RequestDeleteAccountConfirmMutationVariables) => {
    return $gql<RequestDeleteAccountConfirmMutation>(
      `mutation RequestDeleteAccountConfirm($code: String!){requestDeleteAccountConfirm(input:{code: $code}){message success}}`,
      variables,
    );
  };
};

export const useGqlRequestDeleteAccountResendEmail = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RequestDeleteAccountResendEmailMutationVariables) => {
    return $gql<RequestDeleteAccountResendEmailMutation>(
      `mutation RequestDeleteAccountResendEmail{requestDeleteAccountResendEmail{message success}}`,
      variables,
    );
  };
};

export const useGqlRequestDeleteAccountResendSms = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RequestDeleteAccountResendSmsMutationVariables) => {
    return $gql<RequestDeleteAccountResendSmsMutation>(
      `mutation RequestDeleteAccountResendSms{requestDeleteAccountResendSms{message success}}`,
      variables,
    );
  };
};

export const useGqlCheckEmail = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CheckEmailQueryVariables) => {
    return $gql<CheckEmailQuery>(
      `query CheckEmail($email: String!){checkEmail(input:{email: $email}){available}}`,
      variables,
    );
  };
};

export const useGqlConfirmAccountEmailChange = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ConfirmAccountEmailChangeMutationVariables) => {
    return $gql<ConfirmAccountEmailChangeMutation>(
      `mutation ConfirmAccountEmailChange($code: String!){confirmAccountEmailChange(input:{code: $code}){message success}}`,
      variables,
    );
  };
};

export const useGqlRequestAccountEmailChange = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RequestAccountEmailChangeMutationVariables) => {
    return $gql<RequestAccountEmailChangeMutation>(
      `mutation RequestAccountEmailChange($newEmail: String!){requestAccountEmailChange(input:{newEmail: $newEmail}){message success}}`,
      variables,
    );
  };
};

export const useGqlResendEmailChangeConfirmationCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ResendEmailChangeConfirmationCodeMutationVariables) => {
    return $gql<ResendEmailChangeConfirmationCodeMutation>(
      `mutation ResendEmailChangeConfirmationCode($newEmail: String!){resendEmailChangeConfirmationCode(input:{newEmail: $newEmail}){message success}}`,
      variables,
    );
  };
};

export const useGqlPatrimonialData = () => {
  const { $gql } = useNuxtApp();

  return (variables?: PatrimonialDataQueryVariables) => {
    return $gql<PatrimonialDataQuery>(
      `query PatrimonialData{user{patrimonialData{chattel financialInvestments monthlyIncome others personalty realOrAlternative}}}`,
      variables,
    );
  };
};

export const useGqlPopulateUserPatrimonialData = () => {
  const { $gql } = useNuxtApp();

  return (variables?: PopulateUserPatrimonialDataMutationVariables) => {
    return $gql<PopulateUserPatrimonialDataMutation>(
      `mutation PopulateUserPatrimonialData($input: PopulatePatrimonialDataInput!){populateUserPatrimonialData(populatePatrimonialDataInput: $input){message success}}`,
      variables,
    );
  };
};

export const useGqlUpdatePatrimonialData = () => {
  const { $gql } = useNuxtApp();

  return (variables?: UpdatePatrimonialDataMutationVariables) => {
    return $gql<UpdatePatrimonialDataMutation>(
      `mutation UpdatePatrimonialData($input: UpdateUserBasicDetailsDTO!){updateUserBasicDetails(updateUserBasicDetailsDTO: $input){patrimonialData{chattel financialInvestments monthlyIncome others personalty realOrAlternative}}}`,
      variables,
    );
  };
};

export const useGqlPatrimonialDataStatus = () => {
  const { $gql } = useNuxtApp();

  return (variables?: PatrimonialDataStatusQueryVariables) => {
    return $gql<PatrimonialDataStatusQuery>(
      `query PatrimonialDataStatus{user{patrimonialDataStatus}}`,
      variables,
    );
  };
};

export const useGqlCheckPhone = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CheckPhoneQueryVariables) => {
    return $gql<CheckPhoneQuery>(
      `query CheckPhone($phone: String!){checkPhone(input:{phone: $phone}){available}}`,
      variables,
    );
  };
};

export const useGqlConfirmAccountPhoneChange = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ConfirmAccountPhoneChangeMutationVariables) => {
    return $gql<ConfirmAccountPhoneChangeMutation>(
      `mutation ConfirmAccountPhoneChange($code: String!){confirmAccountPhoneChange(input:{code: $code}){message success}}`,
      variables,
    );
  };
};

export const useGqlRequestAccountPhoneChange = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RequestAccountPhoneChangeMutationVariables) => {
    return $gql<RequestAccountPhoneChangeMutation>(
      `mutation RequestAccountPhoneChange($newPhone: String!){requestAccountPhoneChange(input:{newPhone: $newPhone}){message success}}`,
      variables,
    );
  };
};

export const useGqlResendPhoneChangeConfirmationCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ResendPhoneChangeConfirmationCodeMutationVariables) => {
    return $gql<ResendPhoneChangeConfirmationCodeMutation>(
      `mutation ResendPhoneChangeConfirmationCode($newPhone: String!){resendPhoneChangeConfirmationCode(input:{newPhone: $newPhone}){message success}}`,
      variables,
    );
  };
};

export const useGqlAddPixInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: AddPixInfoMutationVariables) => {
    return $gql<AddPixInfoMutation>(
      `mutation AddPixInfo{addPixInfo{__typename}}`,
      variables,
    );
  };
};

export const useGqlPixInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: PixInfoQueryVariables) => {
    return $gql<PixInfoQuery>(
      `query PixInfo{user{pixInfo{value type}}}`,
      variables,
    );
  };
};

export const useGqlRemovePixInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RemovePixInfoMutationVariables) => {
    return $gql<RemovePixInfoMutation>(
      `mutation RemovePixInfo{removePixInfo{__typename}}`,
      variables,
    );
  };
};

export const useGqlAcceptProspectingPortfolio = () => {
  const { $gql } = useNuxtApp();

  return (variables?: AcceptProspectingPortfolioMutationVariables) => {
    return $gql<AcceptProspectingPortfolioMutation>(
      `mutation AcceptProspectingPortfolio($portfolioId: String! $portfolioType: String! $portfolioOperation: [AcceptProspectingPortfolioOperationInput!]!){acceptProspectingPortfolio(input:{portfolioId: $portfolioId portfolioType: $portfolioType portfolioOperation: $portfolioOperation}){accountId baseAssetSymbol id investorEquityOptions items{amount assetSymbol category companyId contractUrl durationTerm estimatedDuration estimatedIRR maxAmount minAmount name operationId originalAmount paymentFrequency}name status totalAmount}}`,
      variables,
    );
  };
};

export const useGqlCancelInvestmentBasket = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CancelInvestmentBasketMutationVariables) => {
    return $gql<CancelInvestmentBasketMutation>(
      `mutation CancelInvestmentBasket($input: CancelInvestmentBasketInput!){cancelInvestmentBasket(input: $input){message success}}`,
      variables,
    );
  };
};

export const useGqlConfirmCodeInvestmentBasket = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ConfirmCodeInvestmentBasketMutationVariables) => {
    return $gql<ConfirmCodeInvestmentBasketMutation>(
      `mutation ConfirmCodeInvestmentBasket($id: String! $code: String $mfaCode: String){confirmCodeInvestmentBasket(input:{id: $id, code: $code, mfaCode: $mfaCode}){__typename}}`,
      variables,
    );
  };
};

export const useGqlConfirmInvestmentBasket = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ConfirmInvestmentBasketMutationVariables) => {
    return $gql<ConfirmInvestmentBasketMutation>(
      `mutation ConfirmInvestmentBasket($id: String! $items: [ConfirmInvestmentBasketItemInput!]!){confirmInvestmentBasket(input:{id: $id, items: $items}){__typename}}`,
      variables,
    );
  };
};

export const useGqlCreatePreProspectingPortfolio = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CreatePreProspectingPortfolioMutationVariables) => {
    return $gql<CreatePreProspectingPortfolioMutation>(
      `mutation CreatePreProspectingPortfolio($portfolioId: String! $portfolioOperation: [CreateProspectingPortfolioOperationInput!]){createPreProspectingPortfolio(input:{portfolioId: $portfolioId portfolioOperation: $portfolioOperation}){message success data{prePortfolioId}}}`,
      variables,
    );
  };
};

export const useGqlFindOneInvestmentBasket = () => {
  const { $gql } = useNuxtApp();

  return (variables?: FindOneInvestmentBasketQueryVariables) => {
    return $gql<FindOneInvestmentBasketQuery>(
      `query FindOneInvestmentBasket($id: String!){findOneInvestmentBasket(input:{id: $id}){baseAssetSymbol id name status totalAmount investorEquityOptions items{amount assetSymbol category companyId contractUrl durationTerm estimatedDuration estimatedIRR maxAmount minAmount name operationId originalAmount paymentFrequency}}user{registerCodeStatus}}`,
      variables,
    );
  };
};

export const useGqlGetBasketOperationsStatus = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetBasketOperationsStatusQueryVariables) => {
    return $gql<GetBasketOperationsStatusQuery>(
      `query GetBasketOperationsStatus($id: String!){getBasketOperationsStatus(input:{id: $id}){isProcessingPayment items{isProcessingPayment operationId transactionStatus}}}`,
      variables,
    );
  };
};

export const useGqlResendInvestmentBasketEmailCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ResendInvestmentBasketEmailCodeMutationVariables) => {
    return $gql<ResendInvestmentBasketEmailCodeMutation>(
      `mutation ResendInvestmentBasketEmailCode($id: String!){resendInvestmentBasketEmailCode(input:{id: $id}){__typename}}`,
      variables,
    );
  };
};

export const useGqlResendInvestmentBasketSmsCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ResendInvestmentBasketSmsCodeMutationVariables) => {
    return $gql<ResendInvestmentBasketSmsCodeMutation>(
      `mutation ResendInvestmentBasketSmsCode($id: String!){resendInvestmentBasketSmsCode(input:{id: $id}){__typename}}`,
      variables,
    );
  };
};

export const useGqlResendInvestmentBasketWhatsappCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ResendInvestmentBasketWhatsappCodeMutationVariables) => {
    return $gql<ResendInvestmentBasketWhatsappCodeMutation>(
      `mutation ResendInvestmentBasketWhatsappCode($id: String!){resendInvestmentBasketWhatsappCode(input:{id: $id}){success}}`,
      variables,
    );
  };
};

export const useGqlUpdateInvestmentBasketInvestorEquity = () => {
  const { $gql } = useNuxtApp();

  return (
    variables?: UpdateInvestmentBasketInvestorEquityMutationVariables,
  ) => {
    return $gql<UpdateInvestmentBasketInvestorEquityMutation>(
      `mutation UpdateInvestmentBasketInvestorEquity($basketId: String! $newInvestorEquity: UpdateInvestmentBasketInvestorEquityEnum!){updateInvestmentBasketInvestorEquity(input:{basketId: $basketId, newInvestorEquity: $newInvestorEquity}){__typename}}`,
      variables,
    );
  };
};

export const useGqlUpdateViewedBasket = () => {
  const { $gql } = useNuxtApp();

  return (variables?: UpdateViewedBasketMutationVariables) => {
    return $gql<UpdateViewedBasketMutation>(
      `mutation UpdateViewedBasket{updateViewedBasket{message success data{viewedBasket}}}`,
      variables,
    );
  };
};

export const useGqlHurstBanks = () => {
  const { $gql } = useNuxtApp();

  return (variables?: HurstBanksQueryVariables) => {
    return $gql<HurstBanksQuery>(
      `query HurstBanks{constants{hurstBankList{agency bank cc code description documentNumber holder id time type}}}`,
      variables,
    );
  };
};

export const useGqlOriginators = () => {
  const { $gql } = useNuxtApp();

  return (variables?: OriginatorsQueryVariables) => {
    return $gql<OriginatorsQuery>(
      `query Originators{constants{originators{id name}}}`,
      variables,
    );
  };
};

export const useGqlConfirmInvestmentWithCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ConfirmInvestmentWithCodeMutationVariables) => {
    return $gql<ConfirmInvestmentWithCodeMutation>(
      `mutation ConfirmInvestmentWithCode($input: ConfirmInvestmentWithCodeInput!){confirmInvestmentWithCode(input: $input){__typename}}`,
      variables,
    );
  };
};

export const useGqlResendCodeConfirmInvestmentEmail = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ResendCodeConfirmInvestmentEmailMutationVariables) => {
    return $gql<ResendCodeConfirmInvestmentEmailMutation>(
      `mutation ResendCodeConfirmInvestmentEmail($input: ResendCodeConfirmInvestmentEmailInput!){resendCodeConfirmInvestmentEmail(input: $input){code message success}}`,
      variables,
    );
  };
};

export const useGqlResendCodeConfirmInvestmentSms = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ResendCodeConfirmInvestmentSmsMutationVariables) => {
    return $gql<ResendCodeConfirmInvestmentSmsMutation>(
      `mutation ResendCodeConfirmInvestmentSms($input: ResendCodeConfirmInvestmentSMSInput!){resendCodeConfirmInvestmentSMS(input: $input){code message success}}`,
      variables,
    );
  };
};

export const useGqlSignContractInvestment = () => {
  const { $gql } = useNuxtApp();

  return (variables?: SignContractInvestmentMutationVariables) => {
    return $gql<SignContractInvestmentMutation>(
      `mutation SignContractInvestment($input: SignContractInvestmentInput!){signContractInvestment(input: $input){__typename}}`,
      variables,
    );
  };
};

export const useGqlUpdateTransaction = () => {
  const { $gql } = useNuxtApp();

  return (variables?: UpdateTransactionMutationVariables) => {
    return $gql<UpdateTransactionMutation>(
      `mutation UpdateTransaction($input: TransactionStatusMutation!){updateTransaction(transaction: $input){__typename}}`,
      variables,
    );
  };
};

export const useGqlHcpPortfolioOperationCashflow = () => {
  const { $gql } = useNuxtApp();

  return (variables?: HcpPortfolioOperationCashflowQueryVariables) => {
    return $gql<HcpPortfolioOperationCashflowQuery>(
      `query HcpPortfolioOperationCashflow($operationId: String!){getOperationCashflow(input:{operationId: $operationId}){items{amountValue category description transactionDate transactionType}}}`,
      variables,
    );
  };
};

export const useGqlActivateIndicationCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ActivateIndicationCodeMutationVariables) => {
    return $gql<ActivateIndicationCodeMutation>(
      `mutation ActivateIndicationCode($input: ActivateIndicationCodeInput!){activateIndicationCode(input: $input){data{indicationCodeUsed}message success}}`,
      variables,
    );
  };
};

export const useGqlCheckIndicationCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CheckIndicationCodeQueryVariables) => {
    return $gql<CheckIndicationCodeQuery>(
      `query CheckIndicationCode($indicationCode: String!){checkIndicationCode(indicationCode: $indicationCode){indicationCode}}`,
      variables,
    );
  };
};

export const useGqlGetAllIndicatedUsers = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetAllIndicatedUsersQueryVariables) => {
    return $gql<GetAllIndicatedUsersQuery>(
      `query GetAllIndicatedUsers($page: PageInput!){getAllIndicatedUsers(page: $page){items{id email fullName dateIndicationCodeUsed cashbackStatus cashbackAmountToTheReferrer accumulatedIndicationInvestback}pageInfo{limit nextPage}}}`,
      variables,
    );
  };
};

export const useGqlIndicationInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: IndicationInfoQueryVariables) => {
    return $gql<IndicationInfoQuery>(
      `query IndicationInfo{indicationInfo{indicatorCode indicatorFullName indicatorId indicatorNid numberOfCreatedAccounts numberOfValidIndications rewardBlocked tokensGivenToIndicatedUsers tokensReceived}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountIndicationCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountIndicationCodeMutationVariables) => {
    return $gql<RegisterAccountIndicationCodeMutation>(
      `mutation RegisterAccountIdGeneratedIndicationCode($input: RegisterAccountGeneratedIndicationCodeInput!){registerAccountIdGeneratedIndicationCode(input: $input){data{indicationCode}message success}}`,
      variables,
    );
  };
};

export const useGqlCheckCoupon = () => {
  const { $gql } = useNuxtApp();

  return (variables?: CheckCouponQueryVariables) => {
    return $gql<CheckCouponQuery>(
      `query CheckCoupon($amountInvested: Float, $coupon: String, $operationId: String, $transactionId: String,){checkCoupon(amountInvested: $amountInvested, coupon: $coupon, operationId: $operationId, transactionId: $transactionId,){value}}`,
      variables,
    );
  };
};

export const useGqlLogin = () => {
  const { $gql } = useNuxtApp();

  return (variables?: LoginMutationVariables) => {
    return $gql<LoginMutation>(
      `mutation Login($input: LoginInput!){login(input: $input){message success data{deviceName registerId status token{refreshToken refreshTokenExpiresIn token}}}}`,
      variables,
    );
  };
};

export const useGqlAvailableOperation = () => {
  const { $gql } = useNuxtApp();

  return (variables?: AvailableOperationQueryVariables) => {
    return $gql<AvailableOperationQuery>(
      `query AvailableOperation($crowdfunding: Boolean!){getAvailableOperation(crowdfunding: $crowdfunding){items{id name baseAssetSymbol url durationTerm estimatedIRR estimatedCompositeIRR estimatedCompositeDuration status startDate endDate estimatedDuration category marketingCategory marketingSubCategory coverImage{high low medium}goal amountConfirmed assetSymbol}}}`,
      variables,
    );
  };
};

export const useGqlOpportunitiesDetail = () => {
  const { $gql } = useNuxtApp();

  return (variables?: OpportunitiesDetailQueryVariables) => {
    return $gql<OpportunitiesDetailQuery>(
      `query OpportunitiesDetail($operationId: String!, $crowdfunding: Boolean){operation(crowdfunding: $crowdfunding, operationId: $operationId){items{estimatedDuration estimatedCompositeDuration companyId endDate baseAssetSymbol durationTerm status mediaInfo{legalDocuments{file title}otherDocuments{file title}}riskRating whyWeLoveInfo{title rows{description image title}}assetName startDate amountCommitted location{city country state}imageInfo{description image title rows{description image title}}goal ratioInfo{title rows{description image title}}subCategory investmentFlowInfo{title rows{description image title}}category marketingCategory marketingSubCategory scenarioInfo{image list{base{IRR IRRTBond durationType durationUnit maximumExposure multipleFactor customProfitability}optmistic{IRR IRRTBond durationType durationUnit maximumExposure multipleFactor customProfitability}pessimistic{IRR IRRTBond durationType durationUnit maximumExposure multipleFactor customProfitability}reviewed{IRR IRRTBond durationType durationUnit maximumExposure multipleFactor customProfitability}}title}assetSymbol faqInfo{title rows{description image title}}minRaise maxRaise visibility originator url name paymentFrequency id multipleFactor assuranceInfo{description title rows{description image title}}risksInfo{description title rows{description image title}}riskType amountConfirmed coverImage{high low medium mobile}estimatedIRR estimatedCompositeIRR disclaimer estimatedEnd type}}}`,
      variables,
    );
  };
};

export const useGqlQueryAddressByZipCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: QueryAddressByZipCodeQueryVariables) => {
    return $gql<QueryAddressByZipCodeQuery>(
      `query QueryAddressByZipCode($zipCode: String!){queryAddressByZipCode(input:{zipCode: $zipCode}){message success data{city country countryCode neighborhood state stateCode street streetShortName zipCode}}}`,
      variables,
    );
  };
};

export const useGqlQueryConstantsByScope = () => {
  const { $gql } = useNuxtApp();

  return (variables?: QueryConstantsByScopeQueryVariables) => {
    return $gql<QueryConstantsByScopeQuery>(
      `query QueryConstantsByScope($language: String, $scope: String!){queryConstantsByScope(input:{language: $language, scope: $scope}){key scope item{type value}}}`,
      variables,
    );
  };
};

export const useGqlGetAddressInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetAddressInfoQueryVariables) => {
    return $gql<GetAddressInfoQuery>(
      `query GetAddressInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){address{city country isPendingValidation latitude longitude neighborhood number postalCode state street complement}language status}}`,
      variables,
    );
  };
};

export const useGqlGetAmountInvestInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetAmountInvestInfoQueryVariables) => {
    return $gql<GetAmountInvestInfoQuery>(
      `query GetAmountInvestInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){investorStarterCategory language status}}`,
      variables,
    );
  };
};

export const useGqlGetBankInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetBankInfoQueryVariables) => {
    return $gql<GetBankInfoQuery>(
      `query GetBankInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){bankInfo{accountNumber achRoutingNumber agency bank bankAddress bankCode bankCountry bankName cc default type wireRoutingNumber}language status}}`,
      variables,
    );
  };
};

export const useGqlGetBasicInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetBasicInfoQueryVariables) => {
    return $gql<GetBasicInfoQuery>(
      `query GetBasicInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){birthdate fullName language nationality registerId taxId advisor indicatedBy partner partnerSlug preRegistrationId}}`,
      variables,
    );
  };
};

export const useGqlGetBiometricDataInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetBiometricDataInfoQueryVariables) => {
    return $gql<GetBiometricDataInfoQuery>(
      `query GetBiometricDataInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){language taxId}}`,
      variables,
    );
  };
};

export const useGqlGetContactInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetContactInfoQueryVariables) => {
    return $gql<GetContactInfoQuery>(
      `query GetContactInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){email phone language status preRegistrationId}}`,
      variables,
    );
  };
};

export const useGqlGetDocumentDataInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetDocumentDataInfoQueryVariables) => {
    return $gql<GetDocumentDataInfoQuery>(
      `query GetDocumentDataInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){language status userIdentification{documentNumber documentType expiryDate fatherName issuingBody issuingDate issuingState motherName}}}`,
      variables,
    );
  };
};

export const useGqlGetInvestorEquityInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetInvestorEquityInfoQueryVariables) => {
    return $gql<GetInvestorEquityInfoQuery>(
      `query GetInvestorEquityInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){investorEquity language status}}`,
      variables,
    );
  };
};

export const useGqlGetPasswordInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetPasswordInfoQueryVariables) => {
    return $gql<GetPasswordInfoQuery>(
      `query GetPasswordInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){language status hasSetPassword}}`,
      variables,
    );
  };
};

export const useGqlGetPatrimonialDataInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetPatrimonialDataInfoQueryVariables) => {
    return $gql<GetPatrimonialDataInfoQuery>(
      `query GetPatrimonialDataInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){patrimonialData{chattel financialInvestments monthlyIncome others personalty realOrAlternative}language status}}`,
      variables,
    );
  };
};

export const useGqlGetPersonalInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetPersonalInfoQueryVariables) => {
    return $gql<GetPersonalInfoQuery>(
      `query GetPersonalInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){maritalStatus profession language gender status}}`,
      variables,
    );
  };
};

export const useGqlGetRegisterAccountValidationInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetRegisterAccountValidationInfoQueryVariables) => {
    return $gql<GetRegisterAccountValidationInfoQuery>(
      `query GetRegisterAccountValidationInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){language status}}`,
      variables,
    );
  };
};

export const useGqlGetStatementInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetStatementInfoQueryVariables) => {
    return $gql<GetStatementInfoQuery>(
      `query GetStatementInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){statements language status}}`,
      variables,
    );
  };
};

export const useGqlGetUploadDocumentInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetUploadDocumentInfoQueryVariables) => {
    return $gql<GetUploadDocumentInfoQuery>(
      `query GetUploadDocumentInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){status language kycFiles{fileName path}}}`,
      variables,
    );
  };
};

export const useGqlGetWhenInvestInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetWhenInvestInfoQueryVariables) => {
    return $gql<GetWhenInvestInfoQuery>(
      `query GetWhenInvestInfo($registerId: String!){queryAccountRegister(input:{registerId: $registerId}){investorExpectedInvestmentDate language status}}`,
      variables,
    );
  };
};

export const useGqlQueryAccountRegisterStatus = () => {
  const { $gql } = useNuxtApp();

  return (variables?: QueryAccountRegisterStatusQueryVariables) => {
    return $gql<QueryAccountRegisterStatusQuery>(
      `query QueryAccountRegisterStatus($registerId: String!){queryAccountRegisterStatus(input:{registerId: $registerId}){status}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountAddress = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountAddressMutationVariables) => {
    return $gql<RegisterAccountAddressMutation>(
      `mutation RegisterAccountAddress($input: RegisterAccountAddressInput!){registerAccountAddress(input: $input){message success data{isPendingValidation status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountAmountInvest = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountAmountInvestMutationVariables) => {
    return $gql<RegisterAccountAmountInvestMutation>(
      `mutation RegisterAccountAmountInvest($amountInvest: String! $registerId: String!){registerAccountAmountInvest(input:{amountInvest: $amountInvest, registerId: $registerId}){message success data{registerId status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountBasicInfo = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountBasicInfoMutationVariables) => {
    return $gql<RegisterAccountBasicInfoMutation>(
      `mutation RegisterAccountBasicInfo($taxId: String $language: String! $birthdate: DateTime $fullName: String $nationality: String $registerId: String $advisor: String $indicatedBy: String $partner: String $partnerSlug: String $preRegistrationId: String $prePortfolioId: String $source: String){registerAccountBasicInfo(input:{birthdate: $birthdate fullName: $fullName language: $language nationality: $nationality taxId: $taxId registerId: $registerId advisor: $advisor indicatedBy: $indicatedBy partner: $partner partnerSlug: $partnerSlug preRegistrationId: $preRegistrationId prePortfolioId: $prePortfolioId source: $source}){message success data{registerId status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountGenerateDocumentUploadUrls = () => {
  const { $gql } = useNuxtApp();

  return (
    variables?: RegisterAccountGenerateDocumentUploadUrlsMutationVariables,
  ) => {
    return $gql<RegisterAccountGenerateDocumentUploadUrlsMutation>(
      `mutation RegisterAccountGenerateDocumentUploadUrls($input: RegisterAccountGenerateDocumentUploadUrlsInput!){registerAccountGenerateDocumentUploadUrls(input: $input){message success data{backPhoto{name signedUrl}frontPhoto{name signedUrl}pdfDocument{name signedUrl}}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountInvestorEquity = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountInvestorEquityMutationVariables) => {
    return $gql<RegisterAccountInvestorEquityMutation>(
      `mutation RegisterAccountInvestorEquity($investorEquity: AccountRegisterQualifiedInvestor! $registerId: String!){registerAccountInvestorEquity(input:{investorEquity: $investorEquity, registerId: $registerId}){message success data{status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountKycValidation = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountKycValidationMutationVariables) => {
    return $gql<RegisterAccountKycValidationMutation>(
      `mutation RegisterAccountKycValidation($registerId: String! $deviceId: String $deviceName: String){registerAccountKycValidation(input:{registerId: $registerId deviceId: $deviceId deviceName: $deviceName}){registerId status}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountPassword = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountPasswordMutationVariables) => {
    return $gql<RegisterAccountPasswordMutation>(
      `mutation RegisterAccountPassword($password: String!, $registerId: String!){registerAccountPassword(input:{password: $password, registerId: $registerId}){message success data{status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountPatrimonialData = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountPatrimonialDataMutationVariables) => {
    return $gql<RegisterAccountPatrimonialDataMutation>(
      `mutation RegisterAccountPatrimonialData($input: RegisterAccountPatrimonialDataInput!){registerAccountPatrimonialData(input: $input){message success data{status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountPersonalData = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountPersonalDataMutationVariables) => {
    return $gql<RegisterAccountPersonalDataMutation>(
      `mutation RegisterAccountPersonalData($registerId: String! $personalData: RegisterAccountPersonalDataItem!){registerAccountPersonalData(input:{personalData: $personalData registerId: $registerId}){message success data{status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountSaveBiometricData = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountSaveBiometricDataMutationVariables) => {
    return $gql<RegisterAccountSaveBiometricDataMutation>(
      `mutation RegisterAccountSaveBiometricData($imageJwtToken: String! $registerId: String!){registerAccountSaveBiometricData(input:{imageJwtToken: $imageJwtToken, registerId: $registerId}){message success data{status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountSaveUserDocuments = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountSaveUserDocumentsMutationVariables) => {
    return $gql<RegisterAccountSaveUserDocumentsMutation>(
      `mutation RegisterAccountSaveUserDocuments($input: RegisterAccountSaveUserDocumentsInput!){registerAccountSaveUserDocuments(input: $input){message success data{status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountSendCodeViaEmail = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountSendCodeViaEmailMutationVariables) => {
    return $gql<RegisterAccountSendCodeViaEmailMutation>(
      `mutation RegisterAccountSendCodeViaEmail($email: String! $registerId: String!){registerAccountSendCodeViaEmail(input:{email: $email, registerId: $registerId}){message success data{canResendEmailAt emailResendDelay}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountSendCodeViaSms = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountSendCodeViaSmsMutationVariables) => {
    return $gql<RegisterAccountSendCodeViaSmsMutation>(
      `mutation RegisterAccountSendCodeViaSms($phone: String!, $registerId: String!){registerAccountSendCodeViaSms(input:{phone: $phone, registerId: $registerId}){message success data{canResendSMSAt codeResendTimeout}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountSendCodeViaWhatsapp = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountSendCodeViaWhatsappMutationVariables) => {
    return $gql<RegisterAccountSendCodeViaWhatsappMutation>(
      `mutation RegisterAccountSendCodeViaWhatsapp($phone: String! $registerId: String!){registerAccountSendCodeViaWhatsapp(input:{phone: $phone, registerId: $registerId}){message success data{codeResendTimeout}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountStatements = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountStatementsMutationVariables) => {
    return $gql<RegisterAccountStatementsMutation>(
      `mutation RegisterAccountStatements($registerId: String! $statements: [String!]!){registerAccountStatements(input:{registerId: $registerId, statements: $statements}){message success data{registerId status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountVerifyEmail = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountVerifyEmailMutationVariables) => {
    return $gql<RegisterAccountVerifyEmailMutation>(
      `mutation RegisterAccountVerifyEmail($code: String!, $email: String!, $registerId: String!){registerAccountVerifyEmail(input:{code: $code, email: $email, registerId: $registerId}){message success data{status verified}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountVerifyPhoneNumber = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountVerifyPhoneNumberMutationVariables) => {
    return $gql<RegisterAccountVerifyPhoneNumberMutation>(
      `mutation RegisterAccountVerifyPhoneNumber($code: String! $phone: String! $registerId: String!){registerAccountVerifyPhoneNumber(input:{code: $code, phone: $phone, registerId: $registerId}){message success data{verified}}}`,
      variables,
    );
  };
};

export const useGqlRegisterAccountWhenInvest = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterAccountWhenInvestMutationVariables) => {
    return $gql<RegisterAccountWhenInvestMutation>(
      `mutation RegisterAccountWhenInvest($expectedInvestmentDate: String! $registerId: String!){registerAccountExpectedInvestmentDate(input:{expectedInvestmentDate: $expectedInvestmentDate registerId: $registerId}){message success data{registerId status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterBankAccount = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterBankAccountMutationVariables) => {
    return $gql<RegisterBankAccountMutation>(
      `mutation RegisterBankAccount($bankInfo: RegisterBankAccountInputBankInfo! $registerId: String! $language: String!){registerBankAccount(input:{bankInfo: $bankInfo, registerId: $registerId, language: $language}){message success data{registerId status}}}`,
      variables,
    );
  };
};

export const useGqlRegisterUserIdentification = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RegisterUserIdentificationMutationVariables) => {
    return $gql<RegisterUserIdentificationMutation>(
      `mutation RegisterUserIdentification($input: RegisterUserIdentificationInput!){registerUserIdentification(input: $input){message success data{status}}}`,
      variables,
    );
  };
};

export const useGqlConfirmResetPassword = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ConfirmResetPasswordMutationVariables) => {
    return $gql<ConfirmResetPasswordMutation>(
      `mutation ConfirmResetPassword($code: String! $login: String! $newPassword: String!){confirmResetPassword(input:{code: $code, login: $login, newPassword: $newPassword}){message success}}`,
      variables,
    );
  };
};

export const useGqlRequestResetPassword = () => {
  const { $gql } = useNuxtApp();

  return (variables?: RequestResetPasswordMutationVariables) => {
    return $gql<RequestResetPasswordMutation>(
      `mutation RequestResetPassword($login: String! $verificationCodeMethod: VerificationCodeMethodEnum!){requestResetPassword(input:{login: $login, verificationCodeMethod: $verificationCodeMethod}){message success}}`,
      variables,
    );
  };
};

export const useGqlResendResetPasswordConfirmationCode = () => {
  const { $gql } = useNuxtApp();

  return (variables?: ResendResetPasswordConfirmationCodeMutationVariables) => {
    return $gql<ResendResetPasswordConfirmationCodeMutation>(
      `mutation ResendResetPasswordConfirmationCode($login: String! $verificationCodeMethod: VerificationCodeMethodEnum!){resendResetPasswordConfirmationCode(input:{login: $login, verificationCodeMethod: $verificationCodeMethod}){message success}}`,
      variables,
    );
  };
};

export const useGqlGetOrCreateTransaction = () => {
  const { $gql } = useNuxtApp();

  return (variables?: GetOrCreateTransactionQueryVariables) => {
    return $gql<GetOrCreateTransactionQuery>(
      `query GetOrCreateTransaction($operationId: String!){getOrCreateTransaction(operationId: $operationId){transaction{transactionId amountCommitted amountConfirmed amountInvested transactionStatus}}}`,
      variables,
    );
  };
};

export const useGqlWalletOperation = () => {
  const { $gql } = useNuxtApp();

  return (variables?: WalletOperationQueryVariables) => {
    return $gql<WalletOperationQuery>(
      `query WalletOperation($operationId: String!){walletOperation(operationId: $operationId){accountOperationFiles{date description fileUrl name}assetName assetSymbol baseAssetSymbol currentCustodyBalance currentMultipleFactor currentPu currentReturnedPercent dateInvested endDateOperation: estimatedEnd estimatedIRR estimatedCompositeIRR income mediaInfo{legalDocuments{title file}otherDocuments{title file}}multipleFactor multipleFactorPrime operationId operationName originalScenarioInfo{list{base{IRR IRRTBond durationType durationUnit multipleFactor}optmistic{IRR IRRTBond durationType durationUnit multipleFactor}pessimistic{IRR IRRTBond durationType durationUnit multipleFactor}reviewed{IRR IRRTBond durationType durationUnit maximumExposure multipleFactor}}}realPu scenarioEstimate{endDate iRR multipleFactor type updatedDate}startDate tokenPrice tokens}}`,
      variables,
    );
  };
};
